export const MODULE_NAME = "DASHBOARD";

export const dashboardLang = {
	pageTitle: "Dashboard",
	filters: "Filters",
	totalAmountLabel: "Number of Application(s): ",
	noResultsFound: "Oops! No transactions match your current filters. Try adjusting them to see more results",
};

export const reportsLang = {
	pageTitle: "Download Reports",
	filters: "Filters",
};
